import React, { useState } from 'react';
import { useIntl } from "umi";
import BubbleClose from '@/pages/home/components/BubbleClose';
import {
  closeFeatureBubble,
  FeatureBubbleConfig,
  isShowFeatureBubble
} from "@/pages/datalab/components/NewFeatureBubble/featureBubbleConfig";
// import './index.scss';

export const useFeatureBubbleProps = (props: any) => {
  const { featureId, onClose, ...restProps } = props;
  const { formatMessage } = useIntl();
  const [visible, setVisible] = useState(isShowFeatureBubble(featureId));
  
  return {
    ...restProps,
    // featureVisible 代表新功能提示展示后, 用户手动关闭等状态处理
    visible,
    content: formatMessage({id: FeatureBubbleConfig[featureId].formatMessageId}),
    onClose: () => {
      // 用户手动关闭时, 触发页面更新
      setVisible(false);
      // 修改localStorage存储的配置, 下次进入无需展示
      closeFeatureBubble(featureId);
      // 外界传入自定义关闭方法
      onClose?.();
    }
  };
};

const NewFeatureBubble = (props: any) => {
  const { featureId, ...restProps } = props;
  return (<BubbleClose
    key={'force'}
    dark
    placement='top-end'
    escapeWithReference
    flipped={false}
    arrowPointAtCenter
    {...restProps}
    visible={true}
    // className={classNames('dbl-new-feature-bubble', className)}
  >
    {props.children}
  </BubbleClose>);
};

export default NewFeatureBubble;